import styled from 'styled-components';
import themeColors, { baseColors } from 'styles/config/colors';
import themeSpacing from 'styles/config/spacing';
import text from 'styles/config/text';

import { CaptionStrong } from 'components/atoms/LegacyText';

const GUTTER_WIDTH = '30px';
const GUTTER_WITH_LINT_WIDTH = '46px';

type GutterExtensionProps = {
  $showLintGutter: boolean;
};

export const Wrapper = styled.div`
  /* stylelint-disable selector-class-pattern */

  position: relative;

  .cm-editor {
    box-sizing: border-box;

    font-family: ${text.font.monospace};
    font-size: 12px;
    font-weight: 500;
    font-style: normal;
    line-height: 18px;

    border: 1px solid ${themeColors.borderStrong};
  }

  &.showCopyButton .cm-editor {
    margin-top: 24px;
  }

  .ͼ2 .cm-content {
    padding: 16px 8px;

    .lineWrapping & {
      word-break: break-word;
      white-space: pre-wrap;
    }
  }

  .cm-placeholder {
    color: ${themeColors.textPlaceholder} !important;
    white-space: normal;
  }

  .codeEditorWithError > .cm-editor {
    border-color: ${baseColors.red['20']} !important;
  }

  .cm-focused {
    box-sizing: border-box;
    border: 1px solid ${themeColors.borderBrand};
    border-radius: ${themeSpacing.radiusSmall};
    outline: none !important;
  }

  .cm-gutters {
    color: ${themeColors.textHelper} !important;
    background-color: ${themeColors.backgroundPage} !important;
    border-right: none !important;
  }

  .cm-activeLine {
    background-color: transparent !important;
  }

  .cm-diagnostic {
    font-family: "Proxima Nova", sans-serif !important;
  }

  .cm-tooltip-autocomplete {
    overflow: hidden;

    font-size: 13px;
    color: ${themeColors.textPrimary};
    text-align: left;

    background-color: ${themeColors.backgroundHover};
    border: 0 !important;
    border-radius: ${themeSpacing.radiusSmall};
    box-shadow: 0 1px 3px rgb(44 44 74 / 30%);

    ul li {
      padding: 8px 12px !important;
      background-color: transparent;
    }

    ul li[aria-selected] {
      color: ${themeColors.textPrimaryInverse} !important;
      background-color: ${themeColors.backgroundBrand} !important;
    }
  }

  .cm-completionIcon {
    display: none !important;
  }

  .cm-completionLabel {
    font-family: "Proxima Nova", sans-serif !important;
    font-weight: 600;
    line-height: 20px;
  }

  .cm-completionDetail {
    display: block;
    margin-left: 0 !important;
    font-size: 12px;
    font-style: normal !important;
  }
`;

export const ErrorCaption = styled(CaptionStrong)`
  position: absolute;
  bottom: -18px;
  color: ${themeColors.errorText01};
`;

export const GutterExtension = styled.div<GutterExtensionProps>`
  position: absolute;
  width: ${p => (p.$showLintGutter ? GUTTER_WITH_LINT_WIDTH : GUTTER_WIDTH)};
  height: 100%;
  background: ${themeColors.backgroundPage};
`;

export const CopyBackground = styled.div<GutterExtensionProps>`
  position: absolute;
  right: 0;
  left: ${p => (p.$showLintGutter ? GUTTER_WITH_LINT_WIDTH : GUTTER_WIDTH)};

  height: 100%;

  background: ${themeColors.background};
`;

export const CopyButton = styled.div`
  position: absolute;
  z-index: 1;
  right: 0;
  padding: ${themeSpacing.xs2};
`;

export const TooltipContent = styled.div`
  display: flex;
  justify-content: center;
`;
